import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';

import {
  GET_RECESS_STATUS_REQUEST,
  GET_RECESS_STATUS_SUCCESS,
  GET_RECESS_STATUS_FAILURE,
  COMMON_FAILURE,
} from '../../actions';
import { recessStatusService } from '../../services';
import { historyType } from '../../../utils/commonType';

export type getRecessStatusAction = {
  type: typeof GET_RECESS_STATUS_REQUEST;
  memberNo: string;
  history: historyType;
};

function* getRecessStatus(action: getRecessStatusAction): Generator<unknown> {
  try {
    const res: any = yield call(recessStatusService(action).getRecessStatus);
    yield put({
      type: GET_RECESS_STATUS_SUCCESS,
      data: res.data,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_RECESS_STATUS_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchGetRecessStatus() {
  yield takeLatest(GET_RECESS_STATUS_REQUEST, getRecessStatus);
}

export default function* recessStatusSaga(): Generator<unknown> {
  yield all([fork(watchGetRecessStatus)]);
}
